import { IConfigItem } from './types';

export const getConfigIndex = (items: IConfigItem[], id: string) => {
  return items.findIndex((item) => item.id === id);
};

export const isConfigItemVisible = (items: IConfigItem[], id: string) => {
  const configItem = items.find((item) => item.id === id);

  return !configItem?.hidden;
};
